<footer class="app-footer" [class.app-footer--dark]="darkMode()" [class.app-footer--compact]="compact()">
  <p>{{ 'app.name' | translate }}</p>
  <div class="app-footer__meta">
    <span>{{ 'footer.internal' | translate }}</span>
    <span>{{ year }}</span>
  </div>
</footer>
